import styled from 'particles/themes/styled'
import { Size } from '..'

interface TextAreaContainerProp {
    width?: number | string
    hasError?: boolean
    minTextAreaHeight?: number
    maxTextAreaHeight?: number
    size: Size
}

export const sizeMap: Record<Size, { minHeight: string; paddingY: string; paddingX: string }> = {
    m: {
        minHeight: '62px',
        paddingY: '9px',
        paddingX: '11px',
    },
    s: {
        minHeight: '54px',
        paddingY: '5px',
        paddingX: '7px',
    },
}

export const TextAreaContainer = styled.div<TextAreaContainerProp>`
    width: ${({ width }): string => (width ? (typeof width === 'string' ? width : width + 'px') : '100%')};
    min-width: 198px;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[200]};
    .input-count-container {
        display: flex;
        flex-direction: column;
        gap: ${({ theme }) => theme.spacing[100]};
    }
    .textarea-input-container {
        width: 100%;
        display: flex;
        height: fit-content;
        border: 1px solid
            ${({ theme, hasError }): string => (hasError ? theme.colors.border.error : theme.colors.border.primary)};
        padding: ${({ size }) => `${sizeMap[size].paddingY} ${sizeMap[size].paddingX}`};
        max-height: ${({ maxTextAreaHeight }) => (maxTextAreaHeight ? maxTextAreaHeight + 'px' : undefined)};
        overflow-y: auto;
        box-sizing: border-box;
        border-radius: 4px;
        gap: ${({ theme }) => theme.spacing[200]};
        &.disabled {
            color: ${({ theme }) => theme.colors.text.disable};
            background-color: ${({ theme }) => theme.colors.surface.disablePastel};
        }
        &.focus {
            color: ${({ theme }) => theme.colors.text.primary};
            border: 1px solid
                ${({ theme, hasError }): string =>
                    hasError ? theme.colors.border.error : theme.colors.border.neutralActionActive};
        }
        ::-webkit-scrollbar {
            -webkit-appearance: none;
            width: 4px;
        }

        ::-webkit-scrollbar-thumb {
            border-radius: 20px;
            background-color: ${({ theme }) => theme.colors.indicator.explosiveGrey};
        }
        textarea,
        .typewriter-effect {
            font-family: inherit;
            font-size: ${({ theme }) => theme.textScale.bodyS400};
            width: 100%;
            height: ${({ minTextAreaHeight, size }): string =>
                minTextAreaHeight ? `${minTextAreaHeight}px` : `${sizeMap[size].minHeight}`};
            border: none;
            resize: none;
            overflow-y: hidden;
            padding: 0;
            outline: none;
            margin: 0 auto;
            ${({ theme }) => theme.textScale.bodyS400};
            color: ${({ theme }) => theme.colors.text.primary};
            background-color: transparent;
            &:disabled {
                color: ${({ theme }) => theme.colors.text.disable};
            }
            &::-webkit-scrollbar {
                display: none;
            }
            &::placeholder {
                color: ${({ theme }) => theme.colors.text.placeholder};
                opacity: 1;
            }
        }
        .icon {
            margin: auto 0;
        }
    }
    .counter-and-error {
        width: 100%;
        max-width: 100%;
        display: flex;
        gap: ${({ theme }) => theme.spacing[200]};
        justify-content: space-between;
        .error {
            width: 100%;
            min-width: 1px;
            word-break: break-word;
        }
    }
    .input-icon {
        flex-shrink: 0;
    }
`
